<template>
	<main id="container" class="page-container">
		<div class="page-header">
			<div class="container">
				<div class="display-flex is-between">
					<page-header title="이벤트" />
				</div>
			</div>
		</div>
		<div class="page-content event-check event-dibs">
			<div class="container">
				<div class="page-sub-header">
					<h3 class="page-sub-title"><span class="prima">동행축제 이벤트에 참여하고</span> 푸짐한 선물 받으세요.</h3>
				</div>
			</div>
			<div class="page-tab-container">
				<div class="container tab-buttons">
					<router-link to="eatingOut" class="tab-button">외식 활성화</router-link>
					<router-link to="check" class="tab-button">출석체크</router-link>
					<router-link to="ranking" class="tab-button">랭킹게임</router-link>
					<router-link to="dibs" class="tab-button is-active">찜하기</router-link>
					<router-link to="sns" class="tab-button">구매후기</router-link>
					<router-link to="delivery" class="tab-button">공공배달앱 이용후기</router-link>
					<router-link to="challenge" class="tab-button">동행 숨결 챌린지</router-link>
				</div>
			</div>
			<div class="container">
				<div class="event-check-container">
					<div class="event-check-header">
						<div class="event-check-header-img">
							<div class="banner-img">
								<img src="@/assets/img/event/event2412_2_2.jpg" alt="EVENT 03 찜하기 이벤트" />
							</div>
						</div>
						<div class="event-check-header-info">
							<ul class="event-check-header-info-list">
								<li v-for="(item, idx) in infoList" :key="idx">
									<span class="infolist-title">{{ item.title }}</span>
									<span class="infolist-text">{{ item.detail }}</span>
								</li>
							</ul>
						</div>
					</div>
					<div class="event-check-guide">
						<span class="event-check-guide-title">참여방법</span>
						<div class="event-check-guide-desc no-border">
							<ul class="event-check-guide-desclist">
								<li class="event-check-guide-desclist-li">
									<div class="event-check-guide-desclist-img hidden-mobile">
										<img src="@/assets/img/event/icon_e21.png" alt="" />
									</div>
									<div class="event-check-guide-desclist-text">
										<span class="desclist-title">STEP 1</span>
										<span class="desclist-text">본인인증을 통한 동행 홈페이지 로그인은 필수입니다.</span>
									</div>
								</li>
								<li class="event-check-guide-desclist-li">
									<div class="event-check-guide-desclist-img hidden-mobile">
										<img src="@/assets/img/event/icon_e22.png" alt="" />
									</div>
									<div class="event-check-guide-desclist-text">
										<span class="desclist-title">STEP 2</span>
										<span class="desclist-text">동행축제 홈페이지의 이벤트 메뉴에서 “찜하기 이벤트 참여” 버튼을 클릭합니다. (참여 버튼 클릭하지 않으면 참여 불가)</span>
									</div>
								</li>
								<li class="event-check-guide-desclist-li">
									<div class="event-check-guide-desclist-img hidden-mobile">
										<img src="@/assets/img/event/icon_e23.png" alt="" />
									</div>
									<div class="event-check-guide-desclist-text">
										<span class="desclist-title">STEP 3</span>
										<span class="desclist-text">동행제품을 둘러보고 5가지 한도 내에서 원하는 제품의 찜(하트)하기 버튼을 클릭하면 응모가 완료 됩니다. (5개 클릭 필수, 3개 클릭 시 응모 X)</span>
									</div>
								</li>
							</ul>
						</div>
					</div>
					<div class="event-check-products">
						<span class="event-check-products-title">경품소개</span>
						<ul class="event-check-products-list">
							<li class="event-check-products-list-li" v-for="(item, idx) in prdList" :key="idx">
								<div class="event-check-products-item">
									<div class="event-check-products-item-img">
										<img :src="require(`@/assets/img/main/${item.img}`)" :alt="item.title" />
									</div>
									<div class="event-check-products-item-title">
										<span class="item-title-wrap">
											<span class="item-title">{{ item.title }}</span>
											<span class="item-title boldtxt">{{ item.person }}</span>
										</span>
									</div>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div class="event-check-button-box">
				<div class="container flex-column">
					<span class="event-check-prect-title">경품발송</span>
					<ul class="event-check-prect-list">
						<li class="event-check-prect-list-li" v-for="(item, idx) in deliveryList" :key="idx">
							<span class="prect-list-text" v-html="item"></span>
						</li>
					</ul>
					<button type="button" v-if="isShowBtn" class="event-check-button" @click="clickAtndCheckEvent">찜하기 이벤트 참여</button>
				</div>
			</div>
			<div class="event-check-prect">
				<div class="container">
					<span class="event-check-prect-title">유의사항</span>
					<ul class="event-check-prect-list">
						<li class="event-check-prect-list-li" v-for="(item, idx) in prectList" :key="idx">
							<span class="prect-list-text">{{ item }}</span>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<event-terms-modal :visible="visibleModal" @closeModal="visibleModal = false" @agreeModal="prvcMktAgrePopup" />
	</main>
</template>

<script>
import PageHeader from '@/components/content/PageHeader';
import EventTermsModal from '@/components/content/EventTermsModal';
import { MUT_SET_RETURN_ROUTE, MUT_SHOW_ALERT, MUT_SHOW_CONFIRM } from '@/store/_mut_consts';
import { ACT_SET_PRVC_MKT_AGRC, ACT_GET_DHFESTA_EVENT_MNG } from '@/store/_act_consts';
import { isSuccess, dateToDateFormat, getItem, lengthCheck, timestampToDateFormat } from '@/assets/js/utils';
import { countDDay } from '@/assets/js/DateUtils';
import { mapGetters } from 'vuex';
export default {
	name: 'EventDibs',
	components: { PageHeader, EventTermsModal },
	data: () => ({
		visibleModal: false,
		infoList: [
			{
				title: '참여기간',
				detail: '2024년 12월 1일(일) ~ 2024년 12월 28일(토)',
			},
			{
				title: '결과발표',
				detail: '2025년 1월 중',
			},
			{
				title: '경품발송',
				detail: '2025년 2월 중',
			},
			{
				title: '진행방식',
				detail: '홈페이지 회원가입 후 참여 가능',
			},
		],
		weekList: [
			{
				name: '일',
				eng: 'SUN',
			},
			{
				name: '월',
				eng: 'MON',
			},
			{
				name: '화',
				eng: 'TUE',
			},
			{
				name: '수',
				eng: 'WED',
			},
			{
				name: '목',
				eng: 'THU',
			},
			{
				name: '금',
				eng: 'FRI',
			},
			{
				name: '토',
				eng: 'SAT',
			},
		],
		prdList: [
			{
				img: 'item_image_6.jpg',
				title: '동행제품 선물박스 20만원 상당',
				person: '(2명)',
			},
			{
				img: 'item_image_10.jpg',
				title: '온누리상품권 5만원',
				person: '(10명)',
			},
			{
				img: 'item_image_5.jpg',
				title: '아이스크림 기프티콘',
				person: '(100명)',
			},
		],
		deliveryList: ['찜하기 참여자 대상으로 추첨을 통해 당첨자 선정', '5만 원 이하 경품 : 회원가입 시 등록한 번호로 모바일 쿠폰 전송', '5만 원 초과 경품 : 개별 연락 후 제세공과금(22%) 납부 안내 및 네이버폼 링크 안내 (배송지 정보) > 제세공과금 납부 확인 후 경품 택배 발송'],

		prectList: ['동행홈페이지 회원가입을 하셔야 참여할 수 있습니다. (카카오 간편가입 별개)', '‘찜하기 이벤트’ 참여 버튼 클릭 후, 약관에 동의해야 이벤트에 응모됩니다.', '당첨자 발표시점까지 찜 상태의 상품이 있어야 이벤트 참여로 인정됩니다.', '배송지 입력을 위한 네이버폼으로 취합된 개인정보는 경품 발송 절차가 완료된 이후에 즉시 폐기 됩니다.', '지급된 쿠폰 사용 시, 쿠폰 내 유의사항을 반드시 확인 바랍니다.', '당첨 쿠폰이 분실, 도난당한 경우, 재발급이 불가합니다. (당첨 쿠폰 복사 및 저장 필수)', '5만원 초과 경품 당첨의 경우 제세공과금(22%)은 본인이 부담해야 합니다.', '당첨자는 이벤트 종료 후 1개월 이내 공지될 예정입니다.', '당첨자의 잘못된 정보 입력으로 인해 경품 누락이 될 경우 재발송되지 않습니다.', '해당 이벤트에 만 14세 미만은 참여할 수 없습니다. (만 14세 미만 참여자의 경우 경품 당첨이 취소됩니다.)', '이벤트 일정 및 경품 내용은 추후 주최 측의 사정에 따라 변동할 수 있습니다.', '경품 발송 전 회원 탈퇴를 하실 경우, 이벤트 대상에서 제외됩니다.', '게임 이벤트에 관한 문의는 게임 운영 대행사인 지엠컴 070-4838-6391로 문의 바라며, 상담 가능 시간은 평일 오전 9시 ~ 오후 6시입니다.'],
		eventStart: false,
		isEvnt: true,
		evntStrtDt: '',
		evntEndDt: '',
	}),
	computed: {
		...mapGetters('common', ['isMobile', 'commonCode', 'campn']),
		...mapGetters('auth', ['session', 'isAuth']),
		isShowBtn() {
			return new Date() < new Date("2024-12-29 00:00:00")
		}
	},
	watch: {},
	filters: {
		getAddMonthKorFilter(val, idx) {
			if (val === '') return '';
			const date = new Date(val);
			let year = date.getFullYear();
			let month = (date.getMonth() + idx + 1) % 13;
			if (month >= 0) {
				year += 1;
				month += 1;
			}
			return `${year}년  ${month}월 중`;
		},
	},
	async created() {
		await this.getEvntMng();
		if (!this.isEvnt) return;
		const tagetDate = new Date(this.evntStrtDt);
		const endDate = new Date(this.evntEndDt);
		// const nowDate = new Date();
		const nowDate = dateToDateFormat(new Date(), 'yyyy-MM-dd') + ' 00:00';
		// console.log(countDDay(tagetDate, nowDate));
		// console.log(countDDay(nowDate, endDate));
		// if (nowDate > tagetDate || nowDate < endDate) {
		if (countDDay(tagetDate, nowDate) < 0 || countDDay(nowDate, endDate) < 0) {
			this.eventStart = false;
		} else {
			this.eventStart = true;
		}

		// this.infoList[0].detail = this.isEvnt ? this.dateKorConvert(this.evntStrtDt) + ' ~ ' + this.dateKorConvert(this.evntEndDt) : '';
		// this.infoList[1].detail = this.isEvnt ? this.evntEndDt : '';
		// this.infoList[2].detail = this.isEvnt ? this.evntEndDt : '';
	},
	mounted() {
		this.$nextTick(() => {
			setTimeout(() => {
				const thisTab = document.querySelector('.tab-button.is-active');
				thisTab.scrollIntoView({ behavior: 'smooth', block: 'center' });
			}, 100);
		});
	},
	methods: {
		clickAtndCheckEvent(e) {
			if (!this.eventStart) {
				this.$store.commit(`common/${MUT_SHOW_ALERT}`, { title: '이벤트 기간이 아닙니다.' });
				return;
			}

			if (!this.chkLogin('로그인 후 이벤트 참여가 가능합니다.')) return false;
			//개인정보 동의 후 진행할 수 있도록 수정
			if (this.campn.prvcMktAgreYn === 'N') {
				this.visibleModal = true;
			} else {
				this.$router.push('/ko/products/category');
			}
		},
		chkLogin(title) {
			if (typeof this.session.userId == 'undefined') {
				const param = {
					title: title,
					html: true,
					showCancelButton: true,
					yesfunc: () => {
						this.$store.commit(`common/${MUT_SET_RETURN_ROUTE}`, this.$route.path);
						this.$router.push({ name: 'Login' });
					},
					nofunc: () => {},
				};
				this.$store.commit(`common/${MUT_SHOW_CONFIRM}`, param);
				return false;
			}

			return true;
		},
		showAlert(msg) {
			this.$store.commit(`common/${MUT_SHOW_ALERT}`, { title: msg });
		},
		async prvcMktAgrePopup() {
			await this.$store.dispatch(`information/${ACT_SET_PRVC_MKT_AGRC}`, { campnId: this.campn.campnId }).then((res) => {
				if (isSuccess(res)) {
					this.campn.prvcMktAgreYn = 'Y';
					this.visibleModal = false;
					this.$router.push('/ko/products/category');
				} else {
					this.$store.commit(`common/${MUT_SHOW_ALERT}`, { title: '오류가 발생했습니다. 다시 시도해주세요.' });
				}
			});
		},
		dateKorConvert(val) {
			const date = new Date(val);
			return `${date.getFullYear()}년  ${('0' + (date.getMonth() + 1)).slice(-2)}월 ${('0' + date.getDate()).slice(-2)}일 (${this.weekList[date.getDay()].name})`;
		},
		async getEvntMng() {
			this.isEvnt = false;
			this.evntStrtDt = '';
			this.evntEndDt = '';

			await this.$store
				.dispatch(`event/${ACT_GET_DHFESTA_EVENT_MNG}`, {
					campnId: this.campn.campnId,
					evntTyp: '20',
				})
				.then((res) => {
					if (lengthCheck(res)) {
						const item = getItem(res);

						this.evntStrtDt = timestampToDateFormat(Number(item.evntStrtDt), 'yyyy-MM-dd') + ' 00:00';
						this.evntEndDt = timestampToDateFormat(Number(item.evntEndDt), 'yyyy-MM-dd') + ' 00:00';

						this.isEvnt = true;
					} else {
						this.evntStrtDt = this.campn.strtDt;
						this.evntEndDt = this.campn.endDt;
					}
				});
		},
	},
};
</script>
